export default __webpack_public_path__ + "static/media/value6.f8a0dd8d.svg";